<template>
  <div :class="['web-004-page', isMobile && 'mobile-page']">
    <carousel
      v-if="cp_carouselImages.length"
      :list="cp_carouselImages"
    />
    <contentList v-if="!isMobile" />
    <contentList_mobile v-else />
  </div>
</template>

<script>
import api from '../../../proxy';
import carousel from '../../components/carousel.vue';
import contentList from '../../components/contentList.vue';
import contentList_mobile from '../../components/contentList_mobile.vue';
export default {
    name: 'AnoahPlatform',
    components: {
        carousel, contentList, contentList_mobile,
    },
    data () {
        return {
            carouselImages: [],
        };
    },
    computed: {
        flatTreeList () {
            return this.$store.getters['system/getFlatTreeList'];
        },
        isMobile () {
            return (/Mobi|Android|iPhone/i.test(navigator.userAgent));
        },
        cp_carouselImages () {
            if (!this.isMobile) {
                return this.carouselImages.filter(itm => itm.status === 1 && [0, 1].includes(itm.clientType));
            }
            return this.carouselImages.filter(itm => itm.status === 1 && [0, 2].includes(itm.clientType));
        },
    },
    watch: {
        flatTreeList (val) {
            this.getCarouselImages();
        },
    },
    mounted () {
        this.getCarouselImages();
    },
    methods: {
        async getCarouselImages () {
            if (this.flatTreeList.length) {
                const { catalogId, siteId } = this.$route.query;
                const item = this.flatTreeList.find(itm => +itm.catalogId === +catalogId);
                if (!item || item.rotation === 0) return;
                const res = item.rotation === 1 ? await api.getRotationList({ siteId, pageNo: 1, pageSize: 999 }) : await api.getCatalogRotationList({ catalogId });
                if (res.errcode === 0) {
                    this.carouselImages = res.data.list || res.data;
                } else {
                    this.$message.error(res.errmsg);
                }
            }
        },
    },
};
</script>

<style scoped lang="scss">
.web-004-page {
    width: 100%;
    min-height: calc(100vh - 200px);
    &.mobile-page {
        min-height: calc(100vh - 160px);
    }
}
</style>
